import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { movies } from "@/mocks/movies";
import { siteHighlights } from "@/mocks/site";
import { formatHeat } from "@/utils/format";

export default function RankingList() {
  const ranking = [...movies].sort((a, b) => b.heat - a.heat).slice(0, 6);

  return (
    <section className="w-full px-4 pt-14 md:px-8 md:pt-20">
      <SectionHeading
        eyebrow="MIDNIGHT CHART"
        title="热门午夜电影排行"
        description="按站内热度实时统计，深夜档观看与检索最多的六部影片。"
        actionLabel="查看完整分类"
        actionTo="/movies"
      />

      <div className="grid grid-cols-1 gap-5 lg:grid-cols-[minmax(0,1fr)_320px]">
        <ol className="overflow-hidden rounded-lg border border-background-800 bg-background-900/70">
          {ranking.map((movie, index) => (
            <li key={movie.id}>
              <Link
                to={`/detail/movie/${movie.id}`}
                className="group flex items-center gap-3 border-b border-background-800/70 px-3 py-3 transition-colors last:border-b-0 hover:bg-background-800/60 md:gap-4 md:px-4 md:py-3.5"
              >
                <span
                  className={`w-8 shrink-0 text-center font-label text-2xl tracking-wider md:text-3xl ${
                    index < 3 ? "text-accent-500" : "text-foreground-600"
                  }`}
                >
                  {String(index + 1).padStart(2, "0")}
                </span>
                <div className="h-16 w-11 shrink-0 overflow-hidden rounded-md border border-background-700 bg-background-800 md:h-20 md:w-14">
                  <img
                    src={movie.poster}
                    alt={`${movie.title} 海报`}
                    title={`${movie.title} - 午夜视频热门排行`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <h3 className="truncate text-sm font-medium text-foreground-50 transition-colors group-hover:text-accent-400">
                    {movie.title}
                  </h3>
                  <p className="mt-1 truncate text-xs text-foreground-500">
                    {movie.year} · {movie.genre} · {movie.region}
                  </p>
                  <p className="mt-1 hidden truncate text-xs text-foreground-500 sm:block">
                    {movie.director} 导演 · {movie.cast}
                  </p>
                </div>
                <div className="hidden shrink-0 items-center gap-1.5 text-xs text-secondary-300 sm:flex">
                  <i className="ri-fire-line text-sm text-accent-500" />
                  {formatHeat(movie.heat)}
                </div>
                <i className="ri-arrow-right-s-line shrink-0 text-lg text-foreground-600 transition-colors group-hover:text-accent-400" />
              </Link>
            </li>
          ))}
        </ol>

        <aside className="flex flex-col gap-4">
          <div className="rounded-lg border border-background-800 bg-primary-950 p-5">
            <h3 className="flex items-center gap-2 font-heading text-sm font-semibold text-foreground-100">
              <i className="ri-moon-clear-line text-base text-accent-500" />
              今夜站点数据
            </h3>
            <div className="mt-4 grid grid-cols-2 gap-3">
              {siteHighlights.map((item) => (
                <div key={item.label} className="rounded-md bg-background-900/70 px-3 py-3">
                  <div className="flex items-center gap-1.5 text-xs text-foreground-500">
                    <i className={`${item.icon} text-sm text-secondary-400`} />
                    {item.label}
                  </div>
                  <p className="mt-1.5 font-label text-xl tracking-wide text-accent-400">
                    {item.value}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="rounded-lg border border-background-800 bg-background-900/70 p-5">
            <h3 className="flex items-center gap-2 font-heading text-sm font-semibold text-foreground-100">
              <i className="ri-lightbulb-flash-line text-base text-accent-500" />
              深夜观影小贴士
            </h3>
            <ul className="mt-4 space-y-3 text-xs leading-6 text-foreground-400">
              <li className="flex gap-2">
                <i className="ri-checkbox-blank-circle-line mt-1 text-[10px] text-accent-500" />
                恐怖类型建议佩戴耳机观看，留意片尾彩蛋。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-blank-circle-line mt-1 text-[10px] text-accent-500" />
                悬疑片单按上映年份排序，可从经典片开始补。
              </li>
              <li className="flex gap-2">
                <i className="ri-checkbox-blank-circle-line mt-1 text-[10px] text-accent-500" />
                本站暂不提供播放，收藏后可稍后回到详情页查看资料。
              </li>
            </ul>
            <Link
              to="/about"
              className="mt-4 inline-flex items-center gap-1.5 whitespace-nowrap text-xs text-accent-400 transition-colors hover:text-accent-300"
            >
              了解平台说明
              <i className="ri-arrow-right-line text-sm" />
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}